export default __webpack_public_path__ + "static/SharpSans-light-41d6905deb476243b17c70b547fe3ee2.otf";